import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.Production) {
  enableProdMode();
}

import { LicenseManager } from '@ag-grid-enterprise/core';
import { AllModules, ModuleRegistry } from '@ag-grid-enterprise/all-modules';

LicenseManager.setLicenseKey('CompanyName=VBT Bilgi Teknolojileri,LicensedGroup=VBT,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-011972,ExpiryDate=20_November_2021_[v2]_MTYzNzM2NjQwMDAwMA==32547af6f7948c6cd605c557b69fb48c');

ModuleRegistry.registerModules(AllModules);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));